import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for balance history.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and data table.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            view: 'datatable', // Data table view
            id: 'datatable', // ID of the data table
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: true, // Enable vertical scrolling
            scheme: {
                $change: function (item) {
                    item.$css = { color: 'red' }; // Change row color to red on certain conditions
                },
            },
            columns: [
                // Column definitions for the data table
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de creación'), // Header text for the column
                    fillspace: 0,
                    minWidth: 0,
                    width: 120,
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format for display
                    footer: 'Total:', // Footer text
                },
                {
                    id: 'Country',
                    header: _('País'), // Header text for the column
                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByCountry', // CSS class for styling
                    width: 50,
                    sort: 'int', // Sorting type
                    template: function (obj) {
                        return "<i class='flags " + obj.Country + "'></i>"; // Template for displaying country flags
                    },
                },
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'UserName',
                    header: _('Nombre Usuario'), // Header text for the column
                    width: 150,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'BalanceInitial',
                    header: _('Saldo Inicial'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AmountDeposits',
                    header: _('Depósitos'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AmountBets',
                    header: _('Ap. Deportivas'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AmountWin',
                    header: _('Pr. Deportivas'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AmountBetsCasino',
                    header: _('Ap. Casino'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AmountWinCasino',
                    header: _('Pr. Casino'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'WithdrawCreates',
                    header: _('Retiros Creados'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'WithdrawDeletes',
                    header: _('Retiros Eliminados'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AdjustmentE',
                    header: _('Ajustes E'), // Header text for the column
                    width: 80,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'AdjustmentS',
                    header: _('Ajustes S'), // Header text for the column
                    width: 80,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'Bonus',
                    header: _('Bonos'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'BalanceEnd',
                    header: _('Saldo Final'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'BalanceEndCalc',
                    header: _('Saldo Final Calc.'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'WithdrawPaid',
                    header: _('Retiros Pagados'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'WithdrawPend',
                    header: _('Retiros Pendientes'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
                {
                    id: 'BonusFreeWin',
                    header: _('Bonos Free Ganados'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for data
                    footer: { content: 'summColumn' }, // Footer content
                },
            ],
            on: {
                // Event handlers for the data table
                onBeforeLoad: function () {
                    this.showOverlay(
                        // Show loading overlay before data load
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay after data load
                },
            },
            ready: function () {
                // Function to execute when the data table is ready
                if (!this.count()) {
                    // Check if there are no items in the table
                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            footer: true, // Enable footer
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        var filter = ''; // Initialize filter variable
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url =
            devConfig.geturlApi() + // API URL for fetching balance history
            'es/BalanceHistory/GetBalanceHistory?PlayerId=' +
            cur_user +
            '&';

        // Event listener for balance history filter
        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 1) {
                        // If Type is 1, show UserId and UserName columns
                        grid.showColumn('UserId', { spans: true });
                        grid.showColumn('UserName', { spans: true });
                    } else {
                        // Otherwise, hide those columns
                        grid.hideColumn('UserId', { spans: true });
                        grid.hideColumn('UserName', { spans: true });
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
